/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-shadow */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable operator-linebreak */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css'
import './styles.css'
import 'moment/locale/pt-br'
import ConfirmEventModal from '@components/modal/confirmEventModal'
import showToast from '@util/ToastUtil'
import colors from '@settings/styleSettings'
import EventModal from '@components/modal/eventModal'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  createEventAction as createEvent,
  getEventsAction as getEvents,
  deleteEventAction as deleteEvent,
  updateEventAction as updateEvent,
} from '@stores/actions/event'
import EventComponent from './EventComponent'

moment.locale('pt-br')
const localizer = momentLocalizer(moment)
const DnDCalendar = withDragAndDrop(Calendar)

const CustomCalendar = ({
  events,
  setEvents,
  date,
  setDate,
  showModal,
  setShowModal,
  createEvent,
  getEvents,
  deleteEvent,
  updateEvent,
}) => {
  const [title, setTitle] = useState('')
  const [desc, setDesc] = useState('')
  const [room, setRoom] = useState('')
  const [startTime, setStartTime] = useState('')
  const [endTime, setEndTime] = useState('')
  const [modalEvent, setModalEvent] = useState(false)
  const [newEvent, setNewEvent] = useState({})
  const [selectedEvent, setSelectedEvent] = useState(null)
  const [isWeekly, setIsWeekly] = useState(false)
  const [isEditing, setIsEditing] = useState(false)

  const formatDateTime = (dateObj) => moment(dateObj).format('YYYY-MM-DDTHH:mm:ss')

  const adaptEvent = (item) => ({
    id: item.id,
    start: new Date(item.start),
    end: new Date(item.end),
    title: item.activityName || '',
    activityId: item.activityId,
    roomId: item.roomId,
    room: item.roomId ? { id: item.roomId, name: item.roomName || '' } : null,
    desc: item.description || '',
    weekly: Boolean(item.weekly),
  })

  const getActivityId = (e) => {
    if (e?.activityId) return e.activityId
    if (e?.title && typeof e.title === 'object' && e.title.id) return e.title.id
    return undefined
  }

  const getRoomId = (e) => {
    if (e?.room?.id) return e.room.id
    if (e?.roomId) return e.roomId
    return undefined
  }

  useEffect(() => {
    getEvents({}, (list) => {
      const safe = (list || [])
        .filter(Boolean)
        .filter((e) => e.deleted !== 1) // <<< blindagem
        .map(adaptEvent)
      setEvents(safe)
    })
  }, [getEvents, setEvents])

  const refreshEvents = () => {
    getEvents({}, (list) => {
      const safe = (list || [])
        .filter(Boolean)
        .filter((e) => e.deleted !== 1) // se a API passar esse campo
        .map(adaptEvent)
      setEvents(safe)
    })
  }

  const validSchedule = (evt) => {
    const startDay = moment(evt.start).day()
    const startHour = moment(evt.start).hour()
    const endHour = moment(evt.end).hour()
    if (startDay === 0 || startDay === 6) {
      showToast('error', 'Não é permitido agendar eventos aos sábados e domingos')
      return false
    }
    if (startHour < 5 || endHour > 20) {
      showToast('error', 'Não é permitido agendar eventos antes das 5 da manhã ou depois das 20 horas')
      return false
    }
    return true
  }

  const isOverlapping = (newEventOver, existingEvents) =>
    existingEvents.some((evt) => {
      const r1 = getRoomId(newEventOver)
      const r2 = getRoomId(evt)
      return r1 && r2 && r1 === r2 && newEventOver.start < evt.end && newEventOver.end > evt.start
    })

  const handleSelectSlot = (slotInfo) => {
    if (!validSchedule(slotInfo)) return
    setNewEvent({
      start: slotInfo.start, end: slotInfo.end, title, desc, room
    })
    setStartTime(slotInfo.start)
    setEndTime(slotInfo.end)
    setShowModal(true)
  }

  const handleEventResize = ({ event, start, end }) => {
    const params = {
      id: event.id,
      activityId: getActivityId(event),
      roomId: getRoomId(event),
      start: formatDateTime(start),
      end: formatDateTime(end),
      description: event.desc,
    }
    updateEvent(params, () => {
      showToast('success', 'Evento editado com sucesso')
      const updatedEvents = events.map((e) => (e.id === event.id ? { ...e, start, end } : e))
      setEvents(updatedEvents)
    })
  }

  const handleEventDrop = ({ event, start, end }) => {
    const updatedEvent = { ...event, start, end }
    if (!validSchedule(updatedEvent)) return
    if (isOverlapping(updatedEvent, events.filter((e) => e.id !== event.id))) {
      showToast('error', 'Já existe um horário reservado para este período')
      return
    }
    const params = {
      id: updatedEvent.id,
      activityId: getActivityId(updatedEvent),
      roomId: getRoomId(updatedEvent),
      start: formatDateTime(updatedEvent.start),
      end: formatDateTime(updatedEvent.end),
      description: updatedEvent.desc,
    }
    updateEvent(params, () => {
      const updated = events.map((e) => (e.id === event.id ? updatedEvent : e))
      setEvents(updated)
      showToast('success', 'Evento editado com sucesso')
    })
  }

  const handleEventDelete = (eventToDelete) => {
    const idToDelete = eventToDelete?.id

    if (!idToDelete) {
      showToast('error', 'Não foi possível identificar o agendamento para exclusão')
      return
    }

    setModalEvent(false)
    setEvents((prev) => prev.filter((evt) => evt.id !== idToDelete))

    const params = { id: idToDelete }
    deleteEvent(params, () => {
      showToast('success', 'Evento deletado com sucesso')
      getEvents({}, (data) => {
        const safe = (data || []).filter(Boolean).map(adaptEvent)
        setEvents(safe)
        clearFields()
      })
    })
  }

  const handleEventClick = (evt) => {
    const id = evt?.id
    console.log('Evento clicado:', evt) // Log do evento completo
    if (!id) {
      showToast('error', 'Não foi possível identificar o agendamento selecionado')
      return
    }
    if (typeof id === 'string' && !/^\d+$/.test(id)) {
      showToast('error', 'Este agendamento ainda não foi persistido no servidor')
      return
    }
    setIsEditing(true)
    setModalEvent(true)
    setSelectedEvent(evt)
  }

  const isActiveEvent = (s, e) => {
    const now = new Date()
    const start = new Date(s)
    const end = new Date(e)
    return now >= start && now <= end
  }

  const eventPropGetter = (evt) => ({
    style: {
      backgroundColor: isActiveEvent(evt.start, evt.end) ? colors.primary : '#B0B0B0',
      boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2)',
    },
  })

  const handleCloseModal = () => {
    clearFields()
    setShowModal(false)
  }

  const handleSaveEvent = () => {
    const newEvt = {
      start: startTime,
      end: endTime,
      title,
      desc,
      room,
    }
    if (!validSchedule(newEvt)) return
    if (isOverlapping(newEvt, events) && !isEditing) {
      showToast('error', 'Já existe um horário reservado para este período')
      return
    }
    const params = {
      activityId: title?.id,
      roomId: room?.id,
      start: formatDateTime(startTime),
      end: formatDateTime(endTime),
      description: desc,
      weekly: isWeekly,
    }
    createEvent(params, () => {
      showToast('success', 'Evento criado com sucesso')
      getEvents({}, (data) => {
        const safe = (data || []).filter(Boolean).map(adaptEvent)
        setEvents(safe)
        setShowModal(false)
      })
    })
    if (!isWeekly) {
      const optimistic = {
        id: `tmp_${Date.now()}`,
        start: new Date(startTime),
        end: new Date(endTime),
        title: title?.name || title || '',
        activityId: title?.id,
        roomId: room?.id,
        room: room ? { id: room.id, name: room.name || '' } : null,
        desc,
        weekly: !!isWeekly,
      }
      setEvents((prev) => [...prev, optimistic])
    }
  }

  const handleEditEvent = (id, activityId) => {
    const updatedEvent = {
      id,
      start: startTime,
      end: endTime,
      title,
      desc,
      room,
    }
    if (!validSchedule(updatedEvent) || isOverlapping(updatedEvent, events.filter((e) => e.id !== id))) {
      showToast('error', 'Já existe um horário reservado para este período')
      return
    }
    const params = {
      id,
      activityId,
      roomId: updatedEvent.room?.id,
      start: formatDateTime(updatedEvent.start),
      end: formatDateTime(updatedEvent.end),
      description: updatedEvent.desc,
      weekly: Boolean(isWeekly),
    }
    const done = () => {
      getEvents({}, (data) => {
        const safe = (data || []).filter(Boolean).map(adaptEvent)
        setEvents(safe)
        showToast('success', 'Evento editado com sucesso')
        setShowModal(false)
        clearFields()
      })
    }
    if (isWeekly) {
      createEvent(params, done)
      return
    }
    updateEvent(params, done)
  }

  const clearFields = () => {
    setDesc('')
    setTitle('')
    setRoom('')
    setStartTime('')
    setEndTime('')
    setNewEvent({})
    setSelectedEvent(null)
    setIsWeekly(false)
    setIsEditing(false)
  }

  const CustomHeader = ({ label, date: dt }) => {
    const dayNumber = label.split(' ')[0]
    const day = label.split(' ')[1]
    const isPickedDate =
      dt.getFullYear() === date.getFullYear() && dt.getMonth() === date.getMonth() && dt.getDate() === date.getDate()
    return (
      <div className={`rbc-header-day-wrapper ${isPickedDate ? 'rbc-header-picked-day' : ''}`}>
        <p className="rbc-header-day">{day[0].toUpperCase()}</p>
        <p className="rbc-header-day-number">{dayNumber}</p>
      </div>
    )
  }

  const draggableAccessorFunc = (evt) => {
    const eventDuration = moment(evt.end).diff(moment(evt.start), 'hours')
    return eventDuration <= 4
  }

  return (
    <div
      style={{
        flex: 1,
        borderRadius: '15px',
        overflow: 'hidden',
        margin: '20px',
        border: '1px solid #ccc',
        backgroundColor: '#fff',
        position: 'relative',
        height: '100%',
        overflowY: 'auto',
      }}
    >
      <DnDCalendar
        localizer={localizer}
        selectable
        events={events}
        onSelectSlot={handleSelectSlot}
        onEventResize={handleEventResize}
        onEventDrop={handleEventDrop}
        resizable
        onSelectEvent={handleEventClick}
        draggableAccessor={draggableAccessorFunc}
        defaultDate={date}
        min={new Date(0, 0, 0, 5)}
        max={new Date(0, 0, 0, 20)}
        resizableAccessor={() => true}
        defaultView="week"
        view="week"
        onNavigate={(navDate) => { setDate(navDate); refreshEvents() }}
        date={date}
        tooltipAccessor="desc"
        className="calendar"
        eventPropGetter={eventPropGetter}
        components={{
          event: EventComponent,
          week: { header: CustomHeader },
        }}
        toolbar={false}
      />

      {showModal && (
        <ConfirmEventModal
          event={newEvent}
          editEvent={selectedEvent}
          setSelectedEvent={setSelectedEvent}
          setEvent={setNewEvent}
          onClose={handleCloseModal}
          onSave={handleSaveEvent}
          onEdit={handleEditEvent}
          onDelete={handleEventDelete}
          title={title}
          setIsEditing={setIsEditing}
          isEditing={isEditing}
          setTitle={setTitle}
          setDesc={setDesc}
          desc={desc}
          setRoom={setRoom}
          startTime={startTime}
          endTime={endTime}
          setStartTime={setStartTime}
          setEndTime={setEndTime}
          IsWeekly={isWeekly}
          setIsWeekly={setIsWeekly}
        />
      )}

      {modalEvent && (
        <EventModal
          showModal={setModalEvent}
          event={selectedEvent}
          onDelete={() => handleEventDelete(selectedEvent)}
          setShowEditModal={(value) => {
            setShowModal(value)
            if (value) setModalEvent(false)
          }}
        />
      )}
    </div>
  )
}

CustomCalendar.propTypes = {
  events: PropTypes.array.isRequired,
  setEvents: PropTypes.func.isRequired,
  date: PropTypes.instanceOf(Date),
  setDate: PropTypes.func,
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  createEvent: PropTypes.func,
  getEvents: PropTypes.func,
  deleteEvent: PropTypes.func,
  updateEvent: PropTypes.func,
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  createEvent, getEvents, deleteEvent, updateEvent
}, dispatch)

export default connect(null, mapDispatchToProps)(CustomCalendar)
